const c = "/static", e = `${c}/library-images/main`, w = "en-au", a = {
  title: "Criminal law",
  description: "Addressing crime and sentencing.",
  image: `${e}/criminal-law.webp`
}, i = {
  title: "Employment law",
  description: "Fairness for employers and employees.",
  image: `${e}/employment-law.webp`
}, t = {
  title: "Commercial law",
  description: "Business transactions and agreements.",
  image: ""
}, n = {
  title: "Family law",
  description: "Separation, divorce, and settlements.",
  image: `${e}/family-law.webp`
}, s = {
  title: "Immigration law",
  description: "Visas, residency, and sponsorships.",
  image: `${e}/immigration-law.webp`
}, o = {
  title: "Litigation",
  description: "Matters involving the courts.",
  image: `${e}/litigation-law.webp`
}, r = {
  title: "Personal injury law",
  description: "Been injured? Help is available.",
  image: `${e}/personal-injury-law.webp`
}, l = {
  title: "Property law",
  description: "Settlements and property disputes.",
  image: `${e}/property-law.webp`
}, m = {
  title: "Estate and probate law",
  description: "Managing and distributing assets.",
  image: `${e}/estate-and-probate-law.webp`
}, p = {
  title: "Case study directory",
  footerTitle: "Browse all areas of law",
  description: "Example cases from all areas of law.",
  image: `${e}/directory.webp`
}, g = ["en-au", "en-gb"], d = {
  "en-au": [
    { ...t, image: `${e}/commercial-law-au.webp` },
    a,
    i,
    m,
    n,
    s,
    o,
    r,
    l
  ],
  "en-gb": [
    { ...t, image: `${e}/commercial-law-gb.webp` },
    a,
    i,
    m,
    n,
    s,
    o,
    r,
    l
  ],
  "en-us": [
    { ...t, image: `${e}/commercial-law-us.webp` },
    a,
    i,
    m,
    n,
    s,
    o,
    r,
    l
  ],
  "en-ie": [
    { ...t, image: `${e}/commercial-law-ie.webp` },
    a,
    i,
    m,
    n,
    s,
    o,
    r,
    l
  ],
  "en-ca": [
    { ...t, image: `${e}/commercial-law-ca.webp` },
    a,
    i,
    m,
    n,
    s,
    o,
    r,
    l
  ]
};
export {
  w as DEFAULT_LANGUAGE_CODE,
  e as IMAGE_BASE_PATH,
  c as STATIC_BASE_PATH,
  d as areasOfLawData,
  p as directoryBaseData,
  g as withDirectoryCountries
};
